import Icon from './_icon';

import {DropdownMenuConstants} from '../modules/constants/dropdown_menu';

import onClickOutside from 'react-onclickoutside';
import classNames from 'classnames';

class DropdownMenu extends React.Component {

  static contextTypes = {
    utils: PropTypes.object.isRequired
  };

  static propTypes = {
    id: PropTypes.string,
    label: PropTypes.string,
    title: PropTypes.string,
    dataTrackingId: PropTypes.string,
    dataTestId: PropTypes.string,
    values: PropTypes.array,
    selectedValue: PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.string
    ]),
    defaultValue: PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.string
    ]),
    showSelectedValueWhenCollapsed: PropTypes.bool,
    className: PropTypes.string,
    selectCallback: PropTypes.func,
    resetCallback: PropTypes.func,
    enableOnClickOutside: PropTypes.func,
    disableOnClickOutside: PropTypes.func,
    children: PropTypes.node,
    parentContextId: PropTypes.number,
    justification: PropTypes.string,
    allowEmptySelection: PropTypes.bool,
    displayDropdownTitle: PropTypes.bool,
    alwaysRenderLabel: PropTypes.bool
  };

  static defaultProps = {
    id: '',
    label: '',
    title: '',
    dataTrackingId: null,
    dataTestId: null,
    values: [],
    selectedValue: '',
    defaultValue: '',
    showSelectedValueWhenCollapsed: true,
    className: '',
    selectCallback() {},
    resetCallback() {},
    enableOnClickOutside() {},
    disableOnClickOutside() {},
    children: null,
    parentContextId: null,
    justification: 'right',
    allowEmptySelection: false,
    displayDropdownTitle: true,
    alwaysRenderLabel: false
  };

  state = {
    isActive: false,
    currentValue: ''
  };

  componentDidMount() {
    // DEBUG
    console.log('DropdownMenu.componentDidMount: props: %o', this.props);
  }

  handleClickOutside = () => {
    if(this.state.isActive) {
      this.handleDropdownToggle();
    }
  };

  handleDropdownToggle = event => {
    if(event) {
      event.preventDefault();
    }

    this.setState(prevState => {
      return {
        isActive: !prevState.isActive
      };
    }, () => {
      if(this.state.isActive) {
        this.props.enableOnClickOutside();
      }
      else {
        this.props.disableOnClickOutside();
      }
    });
  };

  /**
   * Generic dropdown item click handler.
   *
   * @param  {string} ref The ref attribute of the corresponding dropdown
   * @param  {string} val Selected dropdown item value.
   */
  handleDropdownItemClick = (ref, val) => {
    if(val === DropdownMenuConstants.CREATE_NEW_ITEM_REF) {
      this.props.selectCallback(val, {parentContextId: this.props.parentContextId, ref});
    }
    else if(val === DropdownMenuConstants.RESET_ITEM_REF) {
      this.setState({
        currentValue: this.props.defaultValue,
        isActive: false
      }, () => {
        this.props.resetCallback({parentContextId: this.props.parentContextId});
      });
    }
    else {
      this.setState({
        currentValue: val,
        isActive: false
      }, () => {
        this.props.selectCallback(val, {parentContextId: this.props.parentContextId});
      });
    }
  };

  selectValue = newValue => {
    if(this.state.currentValue[1] !== newValue[1]) {
      this.setState({
        currentValue: newValue[1],
        isActive: false
      });
    }
  };

  renderDropdown = () => {
    const {
      selectedValue,
      defaultValue,
      justification,
      allowEmptySelection,
      displayDropdownTitle,
      title,
      alwaysRenderLabel,
      dataTrackingId,
      dataTestId: menuDataTestId
    } = this.props;
    const {isActive, currentValue} = this.state;

    const ref = this.props.id || null;
    const uiDropdownValues = this.props.values || null;
    const uiDropdownTitle = displayDropdownTitle && title && (
      <div className="toolbar-dropdown-heading">{title}</div>
    );

    if(!ref || !uiDropdownValues) {
      return null;
    }

    let uiDefaultUpdatedValue = !allowEmptySelection && (!_.isEmpty(uiDropdownValues[0]) && uiDropdownValues[0][0]);

    if(selectedValue || selectedValue === 0) {
      uiDefaultUpdatedValue = selectedValue;
    }
    else if(currentValue || currentValue === 0) {
      uiDefaultUpdatedValue = currentValue;
    }

    const filterClasses = classNames(`${this.props.className} toolbar-dropdown-group toolbar-dropdown-group--${justification}`, {
      'toolbar-dropdown-group--active': isActive
    });
    const filterDropdownClasses = classNames({
      'toolbar-button': true,
      'toolbar-button--focused': isActive
    });
    const uiDropdownOptions = [];
    let uiCurrentLabel = defaultValue;

    for(let i = 0; i < uiDropdownValues.length; i++) {
      const [itemValue = '', itemLabel = '', showSeparatorAbove = false, extraClasses = '', {trackingId, dataTestId = ''} = {}] = uiDropdownValues[i];
      // checking against selectedValue prop for occassions where actions outside of the dropdown deselects a selected value
      const isCurrent = (itemValue === uiDefaultUpdatedValue) && (selectedValue || selectedValue === 0);
      const itemClasses = classNames(`toolbar-dropdown-button ${extraClasses}`, {
        'toolbar-dropdown-button--active': isCurrent,
        'toolbar-dropdown-button--child': (String(itemValue).indexOf('|') >= 0),
        'toolbar-dropdown-button--default': itemValue === defaultValue,
        'toolbar-dropdown-button--separator': showSeparatorAbove
      });
      let itemActiveIcon;

      if(isCurrent) {
        uiCurrentLabel = itemLabel;
        itemActiveIcon = (
          <div className="toolbar-dropdown-button_icon">
            <Icon icon="check" />
          </div>
        );
      }

      uiDropdownOptions.push(
        <div
          key={`${ref}-item${i}`}
          className={itemClasses}
          data-tracking-id={trackingId}
          data-testid={dataTestId}
          onClick={() => this.handleDropdownItemClick(ref, itemValue)}>
          {itemActiveIcon}<div className="toolbar-dropdown-button_label">{itemLabel}</div>
        </div>
      );
    }

    // remove the label prefix to save space, if default value is equal to a title (call-to-action phrase)
    const renderLabel = alwaysRenderLabel
      ? this.props.label
      : (typeof uiCurrentLabel === 'string' && uiCurrentLabel.includes(this.props.title) ? '' : this.props.label);

    return (
      <div key={ref} className={filterClasses}>
        <div className="toolbar-dropdown-group_trigger">
          <div data-tracking-id={dataTrackingId} className={filterDropdownClasses} onClick={this.handleDropdownToggle} data-testid={menuDataTestId}>
            <div className={this.props.showSelectedValueWhenCollapsed ? 'xtra' : ''}>{renderLabel} </div>
            <div className="toolbar-button_label">{this.props.showSelectedValueWhenCollapsed
              ? (uiCurrentLabel || (!allowEmptySelection && uiDropdownValues[0][1]))
              : null}
            </div>
            <div className="toolbar-button_icon toolbar-button_icon--green toolbar-button_icon--right">
              <Icon icon={isActive ? 'close' : 'arrow-down'} width="16" height="16" />
            </div>
          </div>
        </div>
        <div className="toolbar-dropdown-group_dropdown">
          {uiDropdownTitle}
          <div className="toolbar-dropdown-options">
            {uiDropdownOptions}
          </div>
          {this.props.children}
        </div>
      </div>
    );
  };

  render() {
    return this.renderDropdown();
  }

}

export default onClickOutside(DropdownMenu);
